import {ApprovalStatus} from '@domain/shared'
import {Attachment} from '@hconnect/common/types'

import {ParentTopicDto} from './plantScoring.types'
import {UserDto} from './user.types'

export type ActionSource =
  | 'morningMeeting'
  | 'pom'
  | 'opex'
  | 'mip'
  | 'groupCostBenchmarking'
  | 'managementMeetings'
  | 'bestPracticeIdentified'

export const ACTION_SOURCES: ReadonlyArray<ActionSource> = [
  'morningMeeting',
  'pom',
  'opex',
  'mip',
  'groupCostBenchmarking',
  'managementMeetings',
  'bestPracticeIdentified'
] as const

/** the source that carries an element, see MIP_ELEMENTS */
export const MIP_SOURCE: ActionSource = 'mip'

export const MIP_ELEMENTS = [
  'winterShutdown',
  'subcontractors',
  'costFollowUp',
  'woSystem',
  'weeklyPlanning',
  'dailyReview',
  'earlyMorningMeeting',
  'makingAssignments',
  'skillMatrix',
  'bom',
  'assetNumbering',
  'cmms',
  'standardsAndSpecification',
  'autonomousMaintenance',
  'criticalAssets',
  'fmeaRcfa',
  'shortIntervalControl',
  'preventiveMaintenance'
] as const

export type MipElement = (typeof MIP_ELEMENTS)[number]

export type KpiName =
  | 'heatConsumption'
  | 'powerConsumption'
  | 'alternativeFuelRate'
  | 'clinkerIncorporation'
  | 'other'
  | 'ckSlagOnlyNam'
  | 'purchasedCk'
  | 'rmAndAdd'
  | 'packingMaterial'
  | 'electricalPower'
  | 'fuels'
  | 'consumables'
  | 'co2Emission'
  | 'thirdPartyServices'
  | 'othersVariables'
  | 'personnel'
  | 'thirdPartyRepairServices'
  | 'repairMaterialsAndServices'
  | 'othersFixed'
  | 'leaseExpenses'

export const KPI_NAMES: ReadonlyArray<KpiName> = [
  'heatConsumption',
  'powerConsumption',
  'alternativeFuelRate',
  'clinkerIncorporation',
  'other',
  'ckSlagOnlyNam',
  'purchasedCk',
  'rmAndAdd',
  'packingMaterial',
  'electricalPower',
  'fuels',
  'consumables',
  'co2Emission',
  'thirdPartyServices',
  'othersVariables',
  'personnel',
  'thirdPartyRepairServices',
  'repairMaterialsAndServices',
  'othersFixed',
  'leaseExpenses'
] as const

export const ActionStatus = {
  Pending: 'pending',
  Ongoing: 'ongoing',
  Done: 'done',
  WaitingForApproval: 'waitingForApproval',
  Approved: 'approved',
  Rejected: 'rejected'
} as const

export type ActionStatusType = (typeof ActionStatus)[keyof typeof ActionStatus]

export interface ActionApproverDto {
  user: UserDto
  approvalStatus: ApprovalStatus
}

export interface ActionItemDto {
  actionId: number
  plantUpmId: string
  questionId: string
  title: string
  concurrencyStamp: string
  description: string
  shifthandoverTaskId: string
  assignee?: UserDto
  creator?: UserDto
  updatedBy?: UserDto
  dueDate: string
  createdAt: string
  updatedAt: string
  source: ActionSource
  status: ActionStatusType
  attachments?: Attachment[]
  lockQuestionId: boolean
  parentTopic?: ParentTopicDto
  approvers?: ActionApproverDto[]
  notifyAt?: string
  costLeadership?: boolean
  element?: MipElement
  kpiName?: KpiName
  targetCosts?: string
  actualCostsYtd?: string
  targetKpi?: string
  actualKpiYtd?: string
}
